import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../../context/Provider";
import { GlobalContext } from "../../../../global/context/Provider";
import { multiTabDataMisInformes } from "../../../../global/utils/multiTabData";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import { showModal } from "../../../context/Actions/modal/modal";
import camelize from "../../../../global/utils/camelize";
import { IoChevronDown } from "react-icons/io5";
import "./MultitabMobileMisInformes.css";

const MultitabMobileMisInformes = ({
  posicionMultitab,
  valor,
  datos,
  onChange,
}) => {
  const { modalDispatch, selectDropDownState } = useContext(PortalContext);
  const { authState } = useContext(GlobalContext);

  const handleOpenModalFamiliares = () => {
    showModal(
      "Genericos/ModalSeleccionarFamiliar/ModalSeleccionarFamiliar",
      {
        familiares: datos,
        onSelectFamiliar: onChange,
      },
      [],
      "bottomSheet",
      false,
    )(modalDispatch);
  };

  const getNombrePacienteActual = () => {
    if (selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido) {
      return camelize(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.paciente
          .nombre,
      );
    }
    return camelize(authState?.auth?.data?.paciente?.nombre || "");
  };

  return (
    <React.Fragment>
      <div className="ptur-multitabMobileMisInformes-container">
        <div className="ptur-multitabMobileMisInformes-selector">
          <p
            className="ptur-multitabMobileMisInformes-texto-viendo"
            onClick={handleOpenModalFamiliares}
          >
            Viendo estudios de{""}
            <button className="ptur-multitabMobileMisInformes-nombre-btn">
              <span>{getNombrePacienteActual()}</span>
              <IoChevronDown size={16} />
            </button>
          </p>
        </div>
      </div>
      <div className="ptur-multitabMobileMisInformes-componente-container"></div>
    </React.Fragment>
  );
};

export default MultitabMobileMisInformes;
